import React, { useState } from 'react';
import { Button, ListGroup, Modal, Stack, Table } from 'react-bootstrap';
import { List, ListNested, Building, Plus, BarChart } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import { ItemForm } from '../components/ItemComponents/ItemForm';

export function Home() {
  const navigate = useNavigate();
  const [createModalOpen, setCreateModalOpen] = useState(false)

  return (
    <div className="d-flex flex-wrap gap-3 justify-content-center mx-auto">
      <Button
        className='p-1'
        onClick={() => navigate('/inventory')}
        style={{ height: '150px', width: '150px' }}
        variant="outline-secondary">
        <Stack gap={1} className="align-items-center justify-content-center h-100">
          <ListNested size={64} />
          <span>Inventory</span>
        </Stack>
      </Button>

      <Button
        className='p-1'
        onClick={() => navigate('/warehouse')}
        style={{ height: '150px', width: '150px' }}
        variant="outline-secondary">
        <Stack gap={1} className="align-items-center justify-content-center h-100">
          <Building size={64} />
          <span>Warehouse</span>
        </Stack>
      </Button>

      <Button
        className='p-1'
        onClick={() => setCreateModalOpen(true)}
        style={{ height: '150px', width: '150px' }}
        variant="outline-primary">
        <Stack gap={1} className="align-items-center justify-content-center h-100">
          <Plus size={64} />
          <span>Add Item</span>
        </Stack>
      </Button>

      <Button
        disabled
        className='p-1'
        style={{ height: '150px', width: '150px' }}
        variant="outline-secondary">
        <Stack gap={1} className="align-items-center justify-content-center h-100">
          <BarChart size={64} />
          <span>Reports</span>
        </Stack>
      </Button>

      <Modal show={createModalOpen} onHide={() => setCreateModalOpen(false)}>
        <ItemForm onClose={() => setCreateModalOpen(false)} />
      </Modal>
    </div>
  );
}